import React from 'react';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import IntegrationSection from '../components/IntegrationSection';
import SuccessStoriesSection from '../components/SuccessStoriesSection';
import NewsSection from '../components/NewsSection';
import FaqSection from '../components/FaqSection';
import ContactSection from '../components/ContactSection';

const HomePage = () => (
  <main>
    <HeroSection /> {/* Soluciones Integrales al Comercio Exterior */}
    <ServicesSection /> {/* Nuestras Soluciones Clave */}
    <IntegrationSection /> {/* Integración Tecnológica Sin Límites */}
    <FaqSection /> {/* Preguntas Frecuentes */}
    <NewsSection /> {/* Novedades y Análisis del Sector */}
    <SuccessStoriesSection /> {/* Casos de Éxito */}
    <ContactSection />
  </main>
);

export default HomePage;
